export const GLOBAL_PILOT_COUNT = "GLOBAL_PILOT_COUNT";
